import React, { useState, useEffect } from 'react';
// Using standard HTML date inputs instead of react-datepicker
import axios from 'axios';

import { Alerts, WarningModal } from '../component/notify'
import { config, API_URL, staffCode } from '../component/include';
import { LoadEffect } from '../component/loader';
import PageHeader from '../component/pageheader';
import { formatGroupLabel, getClassArm} from '../component/globalFunction'
import { useSelector } from 'react-redux'
import Select from 'react-select'

const HomeworkCreate = () => {


  const [currentStep, setCurrentStep] = useState(1);
      const schoolClass  = useSelector(state => state.rootReducer.schoolClass);

const [data, setData] =  useState([]);
    const [allSubject, setAllSubject]=useState([]);
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [students, setStudents] = useState([]);
  
  // Step 1 data
  const [classId, setClassId] = useState('');
  const [homeworkDate, setHomeworkDate] = useState(formatDateForInput(new Date()));
  const [returnDate, setReturnDate] = useState(formatDateForInput(new Date(new Date().setDate(new Date().getDate() + 7))));
  
  // Step 2 data
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [subjectDetails, setSubjectDetails] = useState({});
  
  // Step 3 data
  const [assignToAll, setAssignToAll] = useState(true);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [teacherId, setTeacherId] = useState('');
  const [behaviorComments, setBehaviorComments] = useState('');
  const [teacherRemarks, setTeacherRemarks] = useState('');
const [errors, setErrors] = useState({});



    const [homework, setHomework] = useState({
          studentClass:[],
          student:[],
          subject:[],
          orderBy:{value:'order by s.studentName ASC', label:'order by Name'},
      })




      const fetchSubject =()=>{
        let url = API_URL+'/exam/class/subject';
        axios.get(url, config).then(result=>{
            if(result.data.subject.length!==0){
                setAllSubject(result.data.subject)
                setData(result.data.classsubject)
            }else{
                setAllSubject([])
                setData([])
            }
        })
        .catch((error)=>{
            Alerts('Error!', 'danger', error.message)
        })
                
    }


    const getSubjectName = (ID, field) =>{        
      const result = allSubject&&allSubject.filter(list=>list.code === ID);
      return   String(result.map(c=>c[field]));
      }

      const handleSelect = (option, action)=>{
        setHomework({...homework, [action.name]: option });
        
        if(action.name ==='studentClass' && option!==null){
 
         var dt =data.filter(item=>item.sectionID===option.value)
     
     var ans = dt.length>0?JSON.parse(dt[0].subjectDetails):[]

     //loop through ans and get subject name and code then add it to an array list
     var subjectList = []
     ans.forEach(element => {
       element.subjectName = getSubjectName(element.subjectID, 'subjectName')
       element.teacher = getSubjectName(element.teacherID, 'teacher')
       subjectList.push(element)
     });

     setSubjects(subjectList)

     } 
     setError('');
     setErrors({...errors, [action.name]:''})
     }


     const handleNext = () => {
      if (currentStep === 1) {
        if (!homework.studentClass.value) {
          setError('Please select a class');
          return;
        }
        if (!homeworkDate) {
          setError('Please select a homework date');
          return;
        }
        if (!returnDate) {
          setError('Please select a return date');
          return;
        }
        setError('');
        setCurrentStep(2);
  
        
      } else if (currentStep === 2) {
        if (selectedSubjects.length === 0) {
          setError('Please select at least one subject');
          return;
        }
        
        // Validate that all selected subjects have descriptions
        for (const subjectId of selectedSubjects) {
          if (!subjectDetails[subjectId]?.description) {
            setError(`Please provide a description for all selected subjects`);
            return;
          }
        }
        
        setError('');
        setCurrentStep(3);
      }
    };
  


  // Helper function to format date for input[type="date"]
  function formatDateForInput(date) {
    return date.toISOString().split('T')[0];
  }
  
  // Helper function to format date for display
  function formatDateForDisplay(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
  }
  

  useEffect(() => {
    fetchSubject()
   // fetchTeachers();
  }, []);




  useEffect(() => {
    if (homework.studentClass.value) {
      fetchStudentsByClass(homework.studentClass.value);
    }
  }, [homework.studentClass.value]);



 

  const fetchStudentsByClass =(sectionID)=>{
let url = API_URL+'/student/section/'+sectionID
axios.get(url, config).then(result=>{
    
setStudents(result.data.data)
})
.catch((error)=>{
Alerts('Error!', 'danger', error.message)
})
}




  const handleSubjectChange = (subjectId, isChecked) => {
    if (isChecked) {
      setSelectedSubjects([...selectedSubjects, subjectId]);
      setSubjectDetails({
        ...subjectDetails,
        [subjectId]: {
          description: '',
          return_date: returnDate
        }
      });
    } else {
      setSelectedSubjects(selectedSubjects.filter(id => id !== subjectId));
      const newDetails = { ...subjectDetails };
      delete newDetails[subjectId];
      setSubjectDetails(newDetails);
    }

  };



  const handleSubjectDetailChange = (subjectId, field, value) => {
    setSubjectDetails({
      ...subjectDetails,
      [subjectId]: {
        ...subjectDetails[subjectId],
        [field]: value
      }
    });
  };

  const handleStudentChange = (studentId, isChecked) => {
    if (isChecked) {
      setSelectedStudents([...selectedStudents, studentId]);
    } else {
      setSelectedStudents(selectedStudents.filter(id => id !== studentId));
    }
  };

  
  const handleBack = () => {
    setError('');
    setCurrentStep(currentStep - 1);
  };

  const handleSubmit = async () => {
    

    if (!assignToAll && selectedStudents.length === 0) {
      setError('Please select at least one student');
      return;
    }

    setLoading(true);
    setError('');

    const formattedSubjects = selectedSubjects.map(subjectId => ({
      subject_code: subjectId,
      description: subjectDetails[subjectId].description,
      return_date: formatDate(subjectDetails[subjectId].return_date)
    }));

    const payload = {
      classID: homework.studentClass.classID,
      sectionID:homework.studentClass.value,
      homework_date: formatDate(homeworkDate),
      default_return_date: formatDate(returnDate),
      subjects: formattedSubjects,
      assign_to_all: assignToAll,
      student_ids: selectedStudents,
      teacher_id: teacherId,
      behavior_comments: behaviorComments,
      teacher_remarks: teacherRemarks
    };

  
    try {

      const fd = new FormData();
      fd.append("classID", payload.classID);
      fd.append("sectionID", payload.sectionID);
      fd.append("homework_date", payload.homework_date);
      fd.append("default_return_date", payload.default_return_date);
      fd.append("subjects", JSON.stringify(payload.subjects));
      fd.append("assign_to_all", payload.assign_to_all);
      fd.append("student_ids", JSON.stringify(payload.student_ids));
      fd.append("teacher_id", payload.teacher_id);
      fd.append("behavior_comments", payload.behavior_comments);
      fd.append("teacher_remarks", payload.teacher_remarks);
      fd.append("created_by", staffCode);
      const response = await axios.post(`${API_URL}/homework/add`, fd, config);
      if (response.data.status === 'success') {

        setSuccess('Homework created successfully');
        //scroll to top
        window.scrollTo(0, 0);
        setLoading(false);

        setTimeout(() => {
          resetForm();

          window.open('/homework/management', '_self');
        
        }, 2000);


      } else {
        setError('Failed to create homework');
        setLoading(false);
      }
    } catch (error) {
      setError(error?.message || 'Error creating homework');
      setLoading(false);
    } 


  };




  const resetForm = () => {
    setCurrentStep(1);
    setClassId('');
    setHomeworkDate(formatDateForInput(new Date()));
    setReturnDate(formatDateForInput(new Date(new Date().setDate(new Date().getDate() + 7))));
    setSelectedSubjects([]);
    setSubjectDetails({});
    setAssignToAll(true);
    setSelectedStudents([]);
    setTeacherId('');
    setBehaviorComments('');
    setTeacherRemarks('');
    setError('');
    setSuccess('');
  };



  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  };

  const displayDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
  };

  const renderStep1 = () => (
    <div >
      <h5 className="mb-4">Step 1: Class and Date Selection</h5>
      <div className='row'>
      <div className="mb-3 col-sm-4">
      

           <div className="form-group">
         <label> Student Class<span style={{color:'red'}}>*</span></label>
        <Select  options={
                              schoolClass.map((list, idx)=> {
                                return {key:idx, classtype:list.arms, value: list.ID, label: list.cname, options:list.section.map((sec, id)=>{ 
                                    return sec.sname !==''? {key:id, classID:list.ID, classtype:list.arms, isSection:'1', value: sec.ID, label: sec.sname}:{key:id, classtype:list.arms, classID:list.ID, value: list.ID, label: list.cname, isSection:'0'}
                                }) }
                              })
							 
                        } 
                        formatGroupLabel={formatGroupLabel}
onChange={handleSelect}  className={errors.studentClass ? 'form-control form-control-danger' : ''} name="studentClass" value={homework.studentClass} id='sessionId' /> 
<span style={{color:'red'}}>{errors.studentClass && errors.studentClass}</span>

            </div>
     



      </div>
      
      <div className="mb-3 col-sm-4">
        <label className="form-label">Homework Date <span style={{color:'red'}}>*</span></label>
        <input
          type="date"
          value={homeworkDate}
          onChange={(e) => setHomeworkDate(e.target.value)}
          className="form-control"
          required
        />
      </div>
      
      <div className="mb-3 col-sm-4">
        <label className="form-label ">Default Return Date <span style={{color:'red'}}>*</span></label>
        <input
          type="date"
          value={returnDate}
          onChange={(e) => setReturnDate(e.target.value)}
          className="form-control"
          min={homeworkDate}
          required
        />
      </div>
    </div>
    </div>
  );

  const renderStep2 = () => (
    <div>
      <h5 className="mb-4">Step 2: Subject Selection and Assignment Details</h5>
      <div className="mb-4">
        <h6>Select Subjects:</h6>
        <div className="subject-checkboxes ml-4">
          {subjects.map(subject => (
            <div className="form-check mb-2" key={subject.subjectID}>
              <input
                type="checkbox"
                id={`subject-${subject.subjectID}`}
                checked={selectedSubjects.includes(subject.subjectID)}
                onChange={(e) => handleSubjectChange(subject.subjectID, e.target.checked)}
                className="form-check-input"
              />
              <label className="form-check-label" htmlFor={`subject-${subject.subjectID}`}>
                {subject.subjectName}
              </label>
            </div>
          ))}



        </div>
      </div>
      
      {selectedSubjects.length > 0 && (
        <div className="mt-4">
          <h6>Subject Details:</h6>
          {selectedSubjects.map(subjectId => {
            const subject = subjects.find(s => s.subjectID === subjectId);
            
            return (
              <div key={subjectId} className="subject-details mb-4 p-3 border rounded">
                <h6>{subject?.subjectName}</h6>
                
                <div className="mb-3">
                  <label className="form-label">Description of Activities </label>
                  <textarea
                    className="form-control"
                    rows={5}
                    value={subjectDetails[subjectId]?.description || ''}
                    onChange={(e) => handleSubjectDetailChange(subjectId, 'description', e.target.value)}
                    placeholder="Enter homework description"
                    required
                  ></textarea>
                </div>
                
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Return Date</label>
                      <input
                        type="date"
                        value={subjectDetails[subjectId]?.return_date || returnDate}
                        onChange={(e) => handleSubjectDetailChange(subjectId, 'return_date', e.target.value)}
                        className="form-control"
                        min={homeworkDate}
                      />
                      <small className="form-text text-muted">
                        Leave empty to use default return date
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );

  const renderStep3 = () => (
    <div>
      <h5 className="mb-4">Step 3: Assignment and Additional Details</h5>
      
     
      
      <div className="mb-4 ml-4">
        <div>
          <div className="form-check mb-2">
            <input
              type="radio"
              id="assign-all"
              name="assignmentType"
              checked={assignToAll}
              onChange={() => setAssignToAll(true)}
              className="form-check-input"
            />
            <label className="form-check-label" htmlFor="assign-all">
              Assign to entire class
            </label>
          </div>
          <div className="form-check mb-2">
            <input
              type="radio"
              id="assign-selected"
              name="assignmentType"
              checked={!assignToAll}
              onChange={() => setAssignToAll(false)}
              className="form-check-input"
            />
            <label className="form-check-label" htmlFor="assign-selected">
              Assign to selected students
            </label>
          </div>
        </div>
      </div>
      
      {!assignToAll && (
        <div className="mb-4">
          <h6>Select Students:</h6>

          <div className="student-checkboxes ml-4" >
            {students.length > 0 ? (
              students.map(student => (
                <div className="form-check mb-2" key={student.code}>
                  <input
                    type="checkbox"
                    id={`student-${student.code}`}
                    checked={selectedStudents.includes(student.code)}
                    onChange={(e) => handleStudentChange(student.code, e.target.checked)}
                    className="form-check-input"
                  />
                  <label className="form-check-label" htmlFor={`student-${student.code}`}>
                    {`${student.studentName} - ${student.admissionNumber}`}
                  </label>
                </div>



              ))
            ) : (
              <p>No students found in this class</p>
            )}
          </div>
        </div>
      )}
      

      <div>
      <div className="mb-3">
        <label className="form-label">Behavior and Attitude / Well-being Comments</label>
        <textarea
          className="form-control"
          rows={5}
          value={behaviorComments}
          onChange={(e) => setBehaviorComments(e.target.value)}
          placeholder="Enter any comments about behavior, attitude, or well-being"
        ></textarea>
      </div>
      
      <div className="mb-3">
        <label className="form-label">Teacher's Remarks</label>
        <textarea
          className="form-control"
          rows={5}
          value={teacherRemarks}
          onChange={(e) => setTeacherRemarks(e.target.value)}
          placeholder="Enter any additional remarks"
        ></textarea>
      </div>
      </div> 




      <div className="mt-4">
        <h6>Homework Summary:</h6>
        <div className="summary p-3 border rounded bg-light">
          <p><strong>Class:</strong> {homework.studentClass.label}</p>
          <p><strong>Homework Date:</strong> {displayDate(homeworkDate)}</p>
          <p><strong>Default Return Date:</strong> {displayDate(returnDate)}</p>
          <p><strong>Subjects:</strong> {selectedSubjects.map(id => subjects.find(s => s.subjectID === id)?.subjectName).join(', ')}</p>
          <p><strong>Assignment:</strong> {assignToAll ? 'Entire Class' : `${selectedStudents.length} Selected Students`}</p>
            </div>
      </div>
    </div>
  );





  return (
    <div className="main-body">
      <div className="page-wrapper">
        <PageHeader title="Create New Homework">
          <li className="breadcrumb-item">
            <a href="/startup"><i className="fa fa-fw fa-book"></i></a>
          </li>
      
          <li className="breadcrumb-item">
            <a href="/homework/management">Homework</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#!">Create</a>
          </li>
        </PageHeader>
        
        <div className="page-body">
          <div className="row">
            <div className="col-sm-12">
              <div className="card z-depth-0">
                <div className="card-header">
                  <h5>Create New Homework Assignment</h5>
                  <div className="card-header-right">
                    <ul className="list-unstyled card-option">
                      <li><i className="feather icon-maximize full-card"></i></li>
                      <li><i className="feather icon-minus minimize-card"></i></li>
                    </ul>
                  </div>
                </div>
                <div className="card-block">
                  {loading && <LoadEffect className="overlay" />}
                  
                  {error && (
                    <div className="alert alert-danger">{error}</div>
                  )}
                  
                  {success && (
                    <div className="alert alert-success">{success}</div>
                  )}
                  
                  <div className="step-indicator mb-4 d-flex justify-content-between">
                    <div className={`step ${currentStep === 1 ? 'active' : currentStep > 1 ? 'completed' : ''}`} style={{ width: '33.33%' }}>
                      <div className="step-number">1</div>
                      <div className="step-title">Class & Date</div>
                    </div>
                    <div className={`step ${currentStep === 2 ? 'active' : currentStep > 2 ? 'completed' : ''}`} style={{ width: '33.33%' }}>
                      <div className="step-number">2</div>
                      <div className="step-title">Subjects</div>
                    </div>
                    <div className={`step ${currentStep === 3 ? 'active' : ''}`} style={{ width: '33.33%' }}>
                      <div className="step-number">3</div>
                      <div className="step-title">Assignment</div>
                    </div>
                  </div>
                  <div className="progress mt-2 mb-4">
                    <div 
                      className="progress-bar bg-primary" 
                      role="progressbar" 
                      style={{ width: `${((currentStep - 1) / 2) * 100}%` }}
                      aria-valuenow={((currentStep - 1) / 2) * 100} 
                      aria-valuemin="0" 
                      aria-valuemax="100"
                    ></div>
                  </div>
                  
                  {currentStep === 1 && renderStep1()}
                  {currentStep === 2 && renderStep2()}
                  {currentStep === 3 && renderStep3()}
                  
                  <div className="mt-4 d-flex justify-content-between">
                    {currentStep > 1 && (
                      <button type="button" className="btn btn-secondary" onClick={handleBack}>
                        <i className="fa fa-arrow-left mr-1"></i> Back
                      </button>
                    )}
                    
                    <div className="ml-auto">
                      <button type="button" className="btn btn-danger mr-2" onClick={() => window.open('/homework/management', '_self')}>
                        <i className="fa fa-times mr-1"></i> Cancel
                      </button>
                      
                      {currentStep < 3 ? (
                        <button type="button" className="btn btn-primary" onClick={handleNext}>
                          Next <i className="fa fa-arrow-right ml-1"></i>
                        </button>
                      ) : (
                        <button type="button" className="btn btn-success" onClick={handleSubmit}>
                          <i className="fa fa-save mr-1"></i> Create Homework
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .step-number {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background-color: #e9ecef;
          color: #6c757d;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
          font-weight: bold;
        }
        .step.active .step-number {
          background-color: #007bff;
          color: white;
        }
        .step.completed .step-number {
          background-color: #28a745;
          color: white;
        }
        .step-title {
          margin-top: 5px;
          font-size: 0.875rem;
          text-align: center;
        }
      `}</style>
    </div>
  );
};

export default HomeworkCreate;
